/**
 * Transfer wizard — “Transfer To” / company search option label (Angular `loadCompany` parity + QA #88).
 *
 * Angular: for `transfer_property` only, `label: company_name + (listed == 0 ? ' (Not Active)' : '')`
 * (`transfer-process.component.ts`). Loose `==` matches `0`, `'0'`, `false`.
 *
 * QA #88: show **(Active)** / **(Not Active)** in brackets for all Property Maintenance transfer
 * flows that use this company list (`transfer_property`, `transfer_company`, `merge_property`).
 */
const FRAGMENTS_WITH_LISTED_SUFFIX = new Set([
  "transfer_property",
  "transfer_company",
  "merge_property",
])

export function companyOptionLabelWithListedStatus(
  companyName: string,
  listed: unknown,
  fragment: string | null | undefined,
): string {
  const name = String(companyName ?? "")
  if (!fragment || !FRAGMENTS_WITH_LISTED_SUFFIX.has(fragment)) return name
  if (listed == 0) return `${name} (Not Active)`
  if (listed == 1) return `${name} (Active)`
  return name
}
